export const stylesSelectHelperText = {
  color: 'error.main',
};
export const stylesSelect = { px: 0, height: '40px !important' };
